import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/download_dean_code.png';
import _imports_1 from '@/assets/img/gongzonghao.jpg';
const _withScopeId = n => (_pushScopeId("data-v-06844c71"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "asides pointer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {
    "width": "100%"
  }
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "打开浏览器扫码下载", -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {
    "width": "100%"
  }
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "扫一扫关注公众号", -1));
const _hoisted_7 = [_hoisted_5, _hoisted_6];
const _hoisted_8 = ["onClick", "onMouseenter"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "fs-16"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.showIndex == 2 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "white-back enter-mp",
    onMouseleave: _cache[0] || (_cache[0] = $event => $data.showIndex = -1)
  }, _hoisted_4, 32)) : _createCommentVNode("", true), $data.showIndex == 3 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "white-back enter-mp",
    onMouseleave: _cache[1] || (_cache[1] = $event => $data.showIndex = -1),
    style: {
      "top": "140px"
    }
  }, _hoisted_7, 32)) : _createCommentVNode("", true), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      class: "flex-column flex-cc",
      onClick: $event => $options.enterPage(index),
      onMouseenter: $event => $data.showIndex = index
    }, [_createElementVNode("img", {
      src: item.icon,
      alt: "",
      style: {
        "width": "40%"
      }
    }, null, 8, _hoisted_9), _createElementVNode("p", _hoisted_10, _toDisplayString(item.title), 1)], 40, _hoisted_8);
  }), 128))])]);
}